import { render, staticRenderFns } from "./TotalTable.vue?vue&type=template&id=7a68636a&"
import script from "./TotalTable.vue?vue&type=script&lang=js&"
export * from "./TotalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports